import { render, staticRenderFns } from "./learnMore.vue?vue&type=template&id=c1658806&scoped=true"
import script from "./learnMore.vue?vue&type=script&lang=js"
export * from "./learnMore.vue?vue&type=script&lang=js"
import style0 from "./learnMore.vue?vue&type=style&index=0&id=c1658806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1658806",
  null
  
)

export default component.exports